// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__3ilEi","form":"styles_form__weNoG"};